import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CoachLeaderboard from "./CoachLeaderboard";
import Matchmaker from "./Matchmaker";
import Rules from "./Rules";
import TeamsView from "./TeamsView";

const LeagueView = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isBracket = location.pathname === "/league/bracket";
  const isRules = location.pathname === "/league/rules";
  const isTeams = location.pathname === "/league/teams";

  let content = <CoachLeaderboard />;
  if (isBracket) content = <Matchmaker />;
  if (isRules) content = <Rules />;
  if (isTeams) content = <TeamsView />;

  return (
    <div style={styles.page}>
      <h1 className="page-title">League</h1>

      <div style={styles.actionRow} className="sub-nav-bar">
        <button
          type="button"
          aria-pressed={!isBracket && !isRules}
          onClick={() => navigate("/league")}
          style={
            !isBracket && !isRules
              ? { ...styles.actionBtn, ...styles.actionBtnActive }
              : styles.actionBtn
          }
        >
          🏆 Leaders
        </button>
        <button
          type="button"
          aria-pressed={isBracket}
          onClick={() => navigate("/league/bracket")}
          style={
            isBracket
              ? { ...styles.actionBtn, ...styles.actionBtnActive }
              : styles.actionBtn
          }
        >
          ⚔️ Matches
        </button>
        <button
          type="button"
          aria-pressed={isTeams}
          onClick={() => navigate("/league/teams")}
          style={
            isTeams
              ? { ...styles.actionBtn, ...styles.actionBtnActive }
              : styles.actionBtn
          }
        >
          🏊 Teams
        </button>
        <button
          type="button"
          aria-pressed={isRules}
          onClick={() => navigate("/league/rules")}
          style={
            isRules
              ? { ...styles.actionBtn, ...styles.actionBtnActive }
              : styles.actionBtn
          }
        >
          📘 Rules
        </button>
      </div>

      <section style={styles.contentWrap}>{content}</section>
    </div>
  );
};

const styles = {
  page: {
    display: "flex",
    flexDirection: "column",
    gap: "0.55rem",
  },
  actionRow: {
    display: "flex",
    gap: "0.35rem",
    overflowX: "auto",
    WebkitOverflowScrolling: "touch",
    padding: "0",
    borderRadius: "0",
    border: "none",
    backgroundColor: "transparent",
  },
  actionBtn: {
    border: "none",
    backgroundColor: "rgba(7, 20, 60, 0.45)",
    color: "#a6bce6",
    borderRadius: "9px",
    padding: "0.44rem 0.7rem",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.03em",
    fontSize: "0.73rem",
    whiteSpace: "nowrap",
    boxShadow: "0 7px 18px rgba(0, 0, 0, 0.26)",
  },
  actionBtnActive: {
    color: "#02061a",
    backgroundColor: "#00f5d4",
    boxShadow: "0 0 14px rgba(0,245,212,0.3)",
  },
  contentWrap: {
    border: "1px solid rgba(0,245,212,0.34)",
    borderRadius: "14px",
    padding: "0.55rem",
    backgroundColor: "rgba(7, 20, 60, 0.72)",
    boxShadow: "inset 0 0 0 1px rgba(0,245,212,0.08)",
  },
};

export default LeagueView;
